import React from 'react'

export function ProductSkeleton() {
return (
<div className="bg-white rounded-2xl shadow p-4 animate-pulse">
<div className="h-48 bg-gray-300 rounded-xl" />
<div className="h-4 bg-gray-300 rounded mt-4 w-3/4" />
<div className="h-4 bg-gray-200 rounded mt-2 w-1/2" />
<div className="h-10 bg-gray-300 rounded-xl mt-4" />
</div>
);
}